import React from 'react'

import styles from './Student.module.scss';

import StudentPhoto from '../Containers/StudentPhoto';

function Student({ Firstname, Surname, Displayname, Code, Year, Group, ID}) {
  return (
    <div className={styles.Student}>
        <StudentPhoto ID={ID} className={styles.Picture} ></StudentPhoto>
        <div className={styles.Main}>
            <h2>{Displayname} {Surname}</h2>
            <div className={styles.Details}>
                <div className={styles.Detail}>
                    <div>Code</div>
                    <div>{Code}</div>
                </div>
                <div className={styles.Detail}>
                    <div>Year</div>
                    <div>{Year}</div>
                </div>
                <div className={styles.Detail}>
                    <div>Group</div>
                    <div>{Group}</div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Student